export const filterCustomerComplaintData = [
  {
    id: 1,
    primaryText: 'Type',
    subItems: [
      { value: 'Raised', key: 'Status' },
      { value: 'In Review', key: 'Status' },
      { value: 'Resolved', key: 'Status' },
      { value: 'Rejected', key: 'Status' },
    ],
  },
];
